/* tslint:disable:max-line-length */
import React from 'react';
import { IconTypeProps } from '../types';
import classNames from 'classnames';

export const DownloadIcon = ({
  className,
  style,
  color = '#3A50F3',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M12.8906 8.25L8.26562 12.8906C8.11875 13.0375 7.88125 13.0375 7.73438 12.8906L3.10938 8.25C2.9625 8.10313 2.9625 7.86562 3.10938 7.71875L3.33125 7.49687C3.47812 7.35 3.71562 7.35 3.8625 7.49687L7.46875 11.1219V1.375C7.46875 1.16875 7.6375 1 7.84375 1H8.15625C8.3625 1 8.53125 1.16875 8.53125 1.375V11.1219L12.1375 7.5C12.2844 7.35313 12.5219 7.35313 12.6687 7.5L12.8906 7.72188C13.0375 7.86563 13.0375 8.10313 12.8906 8.25ZM14 14.625V14.375C14 14.1687 13.8313 14 13.625 14H2.375C2.16875 14 2 14.1687 2 14.375V14.625C2 14.8313 2.16875 15 2.375 15H13.625C13.8313 15 14 14.8313 14 14.625Z"
        fill={color}
      />
    </svg>
  );
};
